import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { chargebackApi } from '../services/chargebackApi';
export const store = configureStore({
    reducer: {
        [chargebackApi.reducerPath]: chargebackApi.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(chargebackApi.middleware)
});
setupListeners(store.dispatch);
